const digest = '4fc2822517aec283ac52c346238d73577951b08da1577697ae444a01ac234220';
const css = `._modalWrapper_1oyny_1 div{max-width:900px}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'modalWrapper': '_modalWrapper_1oyny_1' };
export const modalWrapper = '_modalWrapper_1oyny_1';
export { css, digest };